import { Pipe, PipeTransform } from '@angular/core';
import { GridItem } from '../grid-control.model';
@Pipe({
  name: 'columnTitle'
})
export class ColumnTitlePipe implements PipeTransform {
  async transform(item: GridItem, title: string, dynamicTitle: ((rowData: any) => string | Promise<string>)): Promise<string> {
    if (!title) {
      return '';
    }
    if (dynamicTitle) {
      const result = dynamicTitle(item);
      if (result instanceof Promise) {
        return (await result) || title;
      }
      return result || title;
    }
    return title;
  }
}
